var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextIndent = function SvgIconTextIndent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.457 4.543a1 1 0 0 0-1.414 1.414L6.086 9l-3.043 3.043a1 1 0 1 0 1.414 1.414l3.75-3.75a1 1 0 0 0 0-1.414zM11.25 5a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zM11.25 11a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zM20.25 19H3.75a1 1 0 1 1 0-2h16.5a1 1 0 1 1 0 2"
  }))));
};
export default SvgIconTextIndent;